import { customAlphabet } from 'nanoid';

const alphaNumericNanoId = customAlphabet(
  '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz',
);

export const anAlphaNumericNanoId = ({ size }: { size?: number } = {}) => alphaNumericNanoId(size);
